var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_66","data-name":"Group 66","transform":"translate(-183 -276)"},[React.createElement("rect",{"id":"Rectangle_114","data-name":"Rectangle 114","width":"14","height":"8","transform":"translate(191 282)","fill":"#e62a2c","key":0}),React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","d":"M10,0,20,10H0Z","transform":"translate(183 296) rotate(-90)","fill":"#e62a2c","key":1})]));
}

Back.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20"};

module.exports = Back;

Back.default = Back;
